import React from 'react'
import { BlogPostCard } from 'newComponents'
import './styles.scss'

const BlogPostSideBar = (props) => {
  const { filteredPosts } = props

  const sixPosts = filteredPosts.slice(0, 6)

  return (
    <section className="blog-post-side-bar">
      <div className="blog-post-side-bar-container">
        {sixPosts.length > 0 && <span className="blog-post-side-bar-title">Recent Stories</span>}
        {sixPosts.length > 0 && (
          <div className="blog-post-side-bar-card-list">
            {sixPosts.map((filteredPost) => (
              <BlogPostCard
                key={filteredPost.uid}
                data={filteredPost.data}
                uid={filteredPost.uid}
                className="related-posts"
              />
            ))}
          </div>
        )}
      </div>
    </section>
  )
}

export default BlogPostSideBar
